import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCard } from '@angular/material/card';
import { ShipmentInfoPreparationTableComponent } from '../shipment-info-preparation-table/shipment-info-preparation-table.component';
import { ShipmentInfoPreparationViewModel } from '../shipment-info-preparation.model';

@Component({
  selector: 'app-shipment-info-not-ready',
  standalone: true,
  imports: [MatCard, ShipmentInfoPreparationTableComponent],
  templateUrl: './shipment-info-not-ready.component.html',
  styleUrl: './shipment-info-not-ready.component.scss',
})
export class ShipmentInfoNotReadyComponent {
  @Input({ required: true })
  public shipmentList: ShipmentInfoPreparationViewModel[] = [];

  @Output() public opened =
    new EventEmitter<ShipmentInfoPreparationViewModel>();
}
